import { asyncLoad, getRouteComponent } from '@util'
import {
  PRIVILEGE_NORMAL_ID,
  PRIVILEGE_STORE_ID,
  PRIVILEGE_GROUP_ID
} from '@constant'
import JiaMengHeader from '@components/JiaMeng/Header/Shop'

const AsyncHome = asyncLoad(() =>
  import('@components/LocalMerchant/Decoration/Home')
)

const AsyncPreview = asyncLoad(() =>
  import('@components/LocalMerchant/Decoration/Preview')
)

const AsyncShowcase = asyncLoad(() =>
  import('@components/LocalMerchant/Decoration/Showcase')
)

const config = {
  role: [PRIVILEGE_NORMAL_ID, PRIVILEGE_STORE_ID, PRIVILEGE_GROUP_ID]
}

export default {
  path: 'decoration',
  component: JiaMengHeader,
  stat: '店铺装修/首页',
  indexRoute: {
    getComponent: getRouteComponent(AsyncHome, config)
  },
  childRoutes: [
    {
      path: 'preview',
      getComponent: getRouteComponent(AsyncPreview, config),
      stat: '店铺装修/店铺预览'
    },
    {
      path: 'showcase',
      getComponent: getRouteComponent(AsyncShowcase, config),
      stat: '店铺装修/优秀店铺范例'
    }
  ]
}
